import { render, staticRenderFns } from "./DownloadTemplateButton.vue?vue&type=template&id=903c0328"
import script from "./DownloadTemplateButton.vue?vue&type=script&lang=js"
export * from "./DownloadTemplateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports